import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import { NavLink } from 'react-router-dom'

// Components
import Navigation from './navigation/Navigation'
import NavigationMobile from './navigationMobile/NavigationMobile'

// JS
import { MOBILEDEVICEWIDTH, DESKTOPTABLETDEVICEWIDTH } from './../../utils/constants'

// CSS
import './Header.css'

class Header extends Component {

  static propTypes = {
    currentActiveMenu: PropTypes.string,
    menuOpen: PropTypes.bool.isRequired,
    onToggleMenu: PropTypes.func.isRequired
  }

  render() {
    const logo = <Link to='/'><h1>Marjolein Varekamp</h1><h2>Children's books & design</h2></Link>

    return (
      <header className="header clearfix">
        <MediaQuery minDeviceWidth={DESKTOPTABLETDEVICEWIDTH}>
          <div className="logo">
            {logo}
          </div>
          <Navigation>
            <li><NavLink to='/work' isActive={this.isWorkUrl} activeClassName="active">Work</NavLink></li>
            <li><NavLink to='/news' activeClassName="active">News</NavLink></li>
            <li><NavLink to='/page/about' activeClassName="active">About</NavLink></li>
            <li><NavLink to='/reviews' activeClassName="active">Reviews</NavLink></li>
            <li><NavLink to='/page/contact' activeClassName="active">Contact</NavLink></li>
          </Navigation>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={MOBILEDEVICEWIDTH}>
          <div className="logo mobile">
            {logo}
          </div>
          <NavigationMobile
            currentActiveMenu={this.props.currentActiveMenu}
            menuOpen={this.props.menuOpen}
            onToggleMenu={this.props.onToggleMenu}
          >
            <li><NavLink to='/work' activeClassName="active">Work</NavLink></li>
            <li><NavLink to='/news' activeClassName="active">News</NavLink></li>
            <li><NavLink to='/reviews' activeClassName="active">Reviews</NavLink></li>
            <li><NavLink to='/page/about' activeClassName="active">About</NavLink></li>
            <li><NavLink to='/page/contact' activeClassName="active">Contact</NavLink></li>
          </NavigationMobile>
        </MediaQuery>
      </header>
    )
  }

  isWorkUrl = (match, location) => {
    return location.pathname === "/" || location.pathname.substring(0, 5) === "/work"
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js